import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { SupplierQuestionnaire } from "@interfaces/models/supplierQuestionnaire.interface";
import { Service } from "@services/service";

@Injectable()
export class SupplierQuestionnaireService extends Service {
	constructor(injector: Injector) {
		super("SupplierQuestionnaire", injector);
	}

	// API
	approve(id: number, comment: string) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Approve/${id}`, { comment });
	}

	forSupplier(supplierId: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForSupplier/${supplierId}`);
	}
	
	public_GetByLookup(lookupId: string) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/Public_GetByLookup/${lookupId}`);
	}

	public_Submit(lookupId: string, questionnaire: SupplierQuestionnaire) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Public_Submit/${lookupId}`, questionnaire);
	}

	// Issues a fresh questionnaire AND clears the supplier's questionnaire/approved flags.
	reset(supplierId: number, recipientEmail: string) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Reset/${supplierId}`, { recipientEmail });
	}

	send(supplierId: number, recipientEmail: string) {
		return this.http.post(`${environment.server.apiURL}/${this.endpoint}/Send/${supplierId}`, { recipientEmail });
	}
}
